/**
 * Advanced Query Search - Clear Button Functionality
 *
 * Handles the clear button to reset search input and trigger form submission.
 */
( function () {
	'use strict';

	/**
	 * Initialize clear button functionality for all search blocks
	 */
	function initSearchClear() {
		const searchBlocks = document.querySelectorAll( '.advanced-query-search' );

		searchBlocks.forEach( ( block ) => {
			const input = block.querySelector( '.advanced-query-search__input' );
			const clearBtn = block.querySelector( '.advanced-query-search__clear' );

			if ( ! input || ! clearBtn ) {
				return;
			}

			// Update has-value class on input change
			input.addEventListener( 'input', () => {
				block.classList.toggle( 'has-value', input.value.length > 0 );
			} );

			// Clear button click handler
			clearBtn.addEventListener( 'click', ( e ) => {
				e.preventDefault();

				// Clear the input
				input.value = '';
				block.classList.remove( 'has-value' );

				// Find the parent form and trigger submission via requestSubmit()
				// Note: form.submit() bypasses event handlers, so we use requestSubmit()
				// which fires the submit event and allows AdvancedQuery to intercept it for AJAX.
				const form = block.closest( 'form' );

				if ( form ) {
					form.requestSubmit();
				}

				// Focus back on input for accessibility
				input.focus();
			} );
		} );
	}

	// Initialize on DOM ready
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initSearchClear );
	} else {
		initSearchClear();
	}
} )();
